import DTO from './DTO';

class ExportDataDTO extends DTO {
  constructor(params, isValidInit) {
    const attributes = [
      {
        name: 'id',
        type: String,
        validators: {},
        labelKey: 'id',
      },
      {
        name: 'type',
        type: Number,
        validators: {},
        labelKey: 'type',
      },
      {
        name: 'uploader_name',
        type: String,
        validators: {},
        labelKey: 'export.data.name',
      },
      {
        name: 'uploader_url',
        type: String,
        validators: {},
        labelKey: 'export.data.url',
      },
      {
        name: 'status',
        type: String,
        validators: {},
        labelKey: 'status',
      },
      {
        name: 'queue',
        type: String,
        validators: {},
        labelKey: 'queue',
      },
      {
        name: 'video_status',
        type: Number,
        validators: {},
        labelKey: 'export.data.video',
      },
      {
        name: 'load_video',
        type: Boolean,
        validators: {},
        labelKey: 'export.data.video',
      },
      {
        name: 'violation_types',
        type: Array,
        validators: {},
        labelKey: 'export.data.violation_types',
      },
      {
        name: 'uploader_username',
        type: String,
        validators: {},
        labelKey: 'login',
      },
      {
        name: 'uploader_password',
        type: String,
        validators: {},
        labelKey: 'password',
      },
    ];
    super(attributes, params, isValidInit);
  }

  getData() {
    return {
      id: this.id,
      type: this.type,
      name: this.name,
      path: this.path,
      status: this.status,
      queue: this.queue,
      video: this.video,
    };
  }
}

export default ExportDataDTO;
